module.exports = __webpack_public_path__ + "static/media/you-have-finalised-icon.06ba9770.svg";